import PropTypes from 'prop-types';
import React from 'react';
import {LOADING} from 'src/shared/currentView/commonViews';
import {
  BILLING_INTERSTITIAL,
  CALL_CANCELLED,
  CALL_CONFIRMED,
  CONFIRM_CANCELLED,
  ERROR,
  LOADING_WITH_TEXT,
  INTERNET_INTERSTITIAL,
  MOVING_INTERSTITIAL,
  OUTAGE_INTERSTITIAL,
  SCHEDULE_CALL,
  SELECT_INTENT,
  TV_INTERSTITIAL,
  UNAVAILABLE,
} from '../../constants/views';
import {main} from '../base.module.scss';
import {BillingInterstitial} from '../BillingInterstitialView';
import {CallCancelledView} from '../CallCancelledView';
import {CallConfirmedView} from '../CallConfirmedView';
import {ConfirmCancelledView} from '../ConfirmCancelledView';
import {ErrorView} from '../ErrorView';
import {InternetInterstitialView} from '../InternetInterstitialView';
import {LoadingView} from '../LoadingView';
import {MovingInterstitialView} from '../MovingInterstitialView';
import {OutageInterstitialView} from '../OutageInterstitialView';
import {ScheduleCallView} from '../ScheduleCallView';
import {SelectIntentView} from '../SelectIntentView';
import {TvInterstitial} from '../TvInterstitialView';
import {UnavailableView} from '../UnavailableView';
import {mainNarrow} from 'src/styles/modules/main.module.scss';

export const ScheduleCallbackPage = ({
  amountDue,
  appointment,
  availableIntents,
  availableTimes,
  billPayUrl,
  continueUrl,
  currentView,
  day,
  email,
  flow,
  hasOutageMessagesSegment,
  intent,
  movingUrl,
  onBillPay,
  onCancel,
  onCancelCallback,
  onComplete,
  onConfirmCancel,
  onConfirmIntent,
  onDayChange,
  onEmailChange,
  onGetCall,
  onInternetRepair,
  onMoving,
  onPhoneChange,
  onScheduleCall,
  onSelectIntent,
  onStatusCenter,
  onSubmit,
  onSupport,
  onTimeslotChange,
  onTryAgain,
  onTvRepair,
  outageMessage,
  phone,
  timeslot,
  timeslots,
  delinquent,
  eligibleForPromiseToPay,
  inSoftDisconnect,
  payByDate,
  onLaunchXfinityAssistant,
}) => (
  <>
    <main className={`${main} ${mainNarrow}`}>
      {
        (() => {
          switch (currentView) {
            case LOADING_WITH_TEXT:
              return (<LoadingView />);
            case LOADING:
              return (
                <LoadingView
                  hideText
                />);
            case SELECT_INTENT:
              return (
                <SelectIntentView
                  availableIntents={availableIntents}
                  flow={flow}
                  onCancel={onCancel}
                  onChange={onSelectIntent}
                  onContinue={onConfirmIntent}
                  selectedIntent={intent}
                />
              );
            case UNAVAILABLE:
              return (
                <UnavailableView
                  availableIntents={availableIntents}
                  onGoToSupport={onCancel}
                  selectedIntent={intent}
                  onLaunchXfinityAssistant={onLaunchXfinityAssistant}
                />
              );
            case SCHEDULE_CALL:
              return (
                <ScheduleCallView
                  availableTimes={availableTimes}
                  day={day}
                  email={email}
                  onCancel={onCancel}
                  onDayChange={onDayChange}
                  onEmailChange={onEmailChange}
                  onPhoneChange={onPhoneChange}
                  onSubmit={onSubmit}
                  onTimeslotChange={onTimeslotChange}
                  phone={phone}
                  timeslot={timeslot}
                  timeslots={timeslots}
                />
              );
            case TV_INTERSTITIAL:
              return (
                <TvInterstitial
                  onGetCall={onGetCall}
                  onTvRepair={onTvRepair}
                />
              );
            case INTERNET_INTERSTITIAL:
              return (
                <InternetInterstitialView
                  onGetCall={onGetCall}
                  onInternetRepair={onInternetRepair}
                />);
            case BILLING_INTERSTITIAL:
              return (
                <BillingInterstitial
                  amountDue={amountDue}
                  billPayUrl={billPayUrl}
                  onGetCall={onGetCall}
                  onBillPay={onBillPay}
                  delinquent={delinquent}
                  eligibleForPromiseToPay={eligibleForPromiseToPay}
                  inSoftDisconnect={inSoftDisconnect}
                  payByDate={payByDate}
                />);
            case OUTAGE_INTERSTITIAL:
              return (
                <OutageInterstitialView
                  hasOutageMessagesSegment={hasOutageMessagesSegment}
                  onScheduleCall={onScheduleCall}
                  onStatusCenter={onStatusCenter}
                  outageMessage={outageMessage}
                />
              );
            case MOVING_INTERSTITIAL:
              return (
                <MovingInterstitialView
                  movingUrl={movingUrl}
                  onGetCall={onGetCall}
                  onMoving={onMoving}
                />
              );
            case CALL_CONFIRMED:
              return (
                <CallConfirmedView
                  email={email}
                  onCancelCallback={onCancelCallback}
                  onComplete={onComplete}
                  phone={phone}
                  appointment={appointment}
                />
              );
            case CALL_CANCELLED:
              return (
                <CallCancelledView
                  continueUrl={continueUrl}
                  onComplete={onComplete}
                  onSupport={onSupport}
                />
              );
            case CONFIRM_CANCELLED:
              return (
                <ConfirmCancelledView
                  appointment={appointment}
                  onCancel={onCancel}
                  onConfirmCancel={onConfirmCancel}
                />
              );
            case ERROR:
              return (
                <ErrorView
                  onCancel={onCancel}
                  onTryAgain={onTryAgain}
                />
              );
            default:
              return null;
          }
        })()
      }
    </main>
  </>
);

ScheduleCallbackPage.propTypes = {
  amountDue: PropTypes.number,
  appointment: PropTypes.object,
  availableIntents: PropTypes.array.isRequired,
  availableTimes: PropTypes.array.isRequired,
  billPayUrl: PropTypes.string.isRequired,
  continueUrl: PropTypes.string.isRequired,
  currentView: PropTypes.string.isRequired,
  day: PropTypes.number.isRequired,
  delinquent: PropTypes.bool.isRequired,
  eligibleForPromiseToPay: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  flow: PropTypes.string.isRequired,
  hasOutageMessagesSegment: PropTypes.bool,
  inSoftDisconnect: PropTypes.bool.isRequired,
  intent: PropTypes.string.isRequired,
  movingUrl: PropTypes.string.isRequired,
  onBillPay: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCancelCallback: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onConfirmCancel: PropTypes.func.isRequired,
  onConfirmIntent: PropTypes.func.isRequired,
  onDayChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onGetCall: PropTypes.func.isRequired,
  onInternetRepair: PropTypes.func.isRequired,
  onMoving: PropTypes.func.isRequired,
  onPhoneChange: PropTypes.func.isRequired,
  onScheduleCall: PropTypes.func.isRequired,
  onSelectIntent: PropTypes.func.isRequired,
  onStatusCenter: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSupport: PropTypes.func.isRequired,
  onTimeslotChange: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func.isRequired,
  onTvRepair: PropTypes.func.isRequired,
  outageMessage: PropTypes.string.isRequired,
  payByDate: PropTypes.string,
  phone: PropTypes.string.isRequired,
  timeslot: PropTypes.string.isRequired,
  timeslots: PropTypes.array.isRequired,
  onLaunchXfinityAssistant: PropTypes.func.isRequired,
};
